var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6d72b2",
    height: 496,
    width: 496,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 0C111 0 0 111 0 248s111 248 248 248 248-111 248-248S385 0 248 0zm0 21c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm-.5 445c-82.941 0-157.263-53.823-207-137.998C67.064 256.372 119.061 207 179.677 207c3.392 0 6.783.81 10.033 2.226 18.368 8.498 37.585 13.962 57.79 13.962s39.563-5.464 57.79-13.962c3.25-1.417 6.641-2.226 10.033-2.226 60.616 0 112.613 49.372 139.177 121.002C404.763 412.177 330.441 466 247.5 466z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bd7d9d280bbdefe4f7524c9a1036071c.svg";
export { ForwardRef as ReactComponent };